import chroma from 'chroma-js';

import {OptionType} from '@components/ux/ProblemCollection/functions/types';

export const styles = {
    container: {
        display: 'flex',
        gap: '16px',
        alignItems: 'center',
        maxWidth: 'fit-content',
    },
    colorBox: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
    },
    colorSwatch: (color: string) => ({
        display: 'inline-block',
        width: '16px',
        height: '16px',
        backgroundColor: chroma(color).alpha(0.8).css(),
        borderRadius: '2px',
    }),
};
export const colorStyles = {
    control: (styles: any) => ({...styles}),
    option: (
        styles: any,
        {
            data,
            isDisabled,
            isFocused,
            isSelected,
        }: {
            data: OptionType;
            isDisabled: boolean;
            isFocused: boolean;
            isSelected: boolean;
        }
    ) => {
        const color = chroma(data.color);
        return {
            ...styles,
            backgroundColor: isDisabled
                ? undefined
                : isSelected
                  ? data.color
                  : isFocused
                    ? color.alpha(0.1).css()
                    : data.isFavourite
                      ? chroma(data.color).alpha(0.1).css()
                      : undefined,
            color: isDisabled
                ? '#ccc'
                : isSelected
                  ? chroma.contrast(color, 'white') > 2
                      ? 'white'
                      : 'black'
                  : data.color,
            cursor: isDisabled ? 'not-allowed' : 'default',
            ':active': {
                ...styles[':active'],
                backgroundColor: !isDisabled
                    ? isSelected
                        ? data.color
                        : color.alpha(0.3).css()
                    : undefined,
            },
        };
    },
    multiValue: (styles: any, {data}: any) => {
        const color = chroma(data.color);
        return {
            ...styles,
            backgroundColor: color.alpha(0.15).css(),
        };
    },
    multiValueLabel: (styles: any, {data}: any) => {
        const color = chroma(data.color);
        return {
            ...styles,
            color: color.darken(3).css(),
        };
    },
    multiValueRemove: (styles: any, {data}: any) => {
        const color = chroma(data.color);
        return {
            ...styles,
            color: color.darken(3).css(),
            ':hover': {
                backgroundColor: data.color,
                color: 'white',
            },
        };
    },
};
